// SUMMARY: Non-translatable marketing configuration (anchors, artwork, plan numbers, link targets)

export const MARKETING_NAV = [
	{ key: 'purpose', href: '/#purpose' },
	{ key: 'features', href: '/#features' },
	{ key: 'pricing', href: '/#pricing' },
] as const

export const FEATURE_ITEMS = [
	{ key: 'inventory', id: 'inventory', image: '/images/feature-inventory.webp', height: 625 },
	{ key: 'orders', id: 'orders', image: '/images/feature-orders.webp', height: 320 },
	{ key: 'picking', id: 'picking', image: '/images/feature-picking.webp', height: 320 },
	{ key: 'shipping', id: 'shipping', image: '/images/feature-shipping.webp', height: 320 },
] as const

export type FeatureKey = (typeof FEATURE_ITEMS)[number]['key']

// NOTE: placeholder tiers - replace with the real commercial model before launch
export const PRICING_PLANS = [
	{ key: 'starter', price: 99, ordersPerMonth: 2_500, surface: 'lift' },
	{ key: 'growth', price: 299, ordersPerMonth: 15_000, surface: 'lift' },
	{ key: 'scale', price: 799, ordersPerMonth: 60_000, surface: 'depth' },
] as const

export type PlanKey = (typeof PRICING_PLANS)[number]['key']

// NOTE: placeholder customer wordmarks until real logos are provided
export const MARQUEE_LOGOS = ['NORDKAP', 'Halden & Co', 'VELOX', 'Brückner', 'MERIDIAN', 'Oststrom'] as const

export const FOOTER_LINK_GROUPS = [
	{
		key: 'product',
		links: [
			{ key: 'home', href: '/' },
			{ key: 'features', href: '/#features' },
			{ key: 'pricing', href: '/#pricing' },
		],
	},
	{
		key: 'company',
		links: [
			{ key: 'contact', href: 'mailto:info@redstone-it.de' },
			{ key: 'changelog', href: '/changelog' },
		],
	},
	{
		key: 'legal',
		links: [
			{ key: 'privacy', href: '/privacy-policy' },
			{ key: 'terms', href: '/terms-of-use' },
		],
	},
] as const

export const SIGN_IN_HREF = '/sign-in'
export const APP_HREF = '/app'
